import { COURSE_TOKEN_KEY } from '../constants/courseConstants';

export function getCourseStudentToken() {
  return localStorage.getItem(COURSE_TOKEN_KEY);
}

export function setCourseStudentToken(token) {
  if (token) {
    localStorage.setItem(COURSE_TOKEN_KEY, token);
  } else {
    localStorage.removeItem(COURSE_TOKEN_KEY);
  }
}

export function clearCourseStudentToken() {
  localStorage.removeItem(COURSE_TOKEN_KEY);
}
